import React, { useState, useId } from "react";
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";

export default function CInput({
  label,
  type = "text",
  labelProps,
  touched,
  errors,
  id,
  isRequired,
  ...inputProps
}) {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(!show);
  const generatedId = useId();
  const inputId = id || generatedId;
  const errorId = `${inputId}-error`;
  const hasError = errors && touched;

  return (
    <FormControl isInvalid={hasError}>
      {label && (
        <FormLabel fontWeight="semibold" htmlFor={inputId} {...labelProps}>
          {isRequired ? (
            <>
              <Text as="span" color="red.500" aria-hidden>
                *
              </Text>{" "}
            </>
          ) : null}
          {label}
        </FormLabel>
      )}
      {type === "textarea" ? (
        <Textarea
          id={inputId}
          bg="white"
          borderRadius="lg"
          focusBorderColor="primary.main"
          aria-invalid={hasError}
          aria-describedby={hasError ? errorId : undefined}
          {...inputProps}
        />
      ) : type === "password" ? (
        <InputGroup>
          <Input
            id={inputId}
            pr="3rem"
            type={show ? "text" : "password"}
            bg="white"
            borderRadius="lg"
            focusBorderColor="primary.main"
            aria-invalid={hasError}
            aria-describedby={hasError ? errorId : undefined}
            {...inputProps}
          />
          <InputRightElement width="3rem">
            <IconButton
              aria-label={show ? "Hide password" : "Show password"}
              color={show ? "primary.main" : "gray"}
              bgColor="transparent"
              fontSize="24px"
              icon={show ? <AiFillEyeInvisible /> : <AiFillEye />}
              onClick={handleShow}
            />
          </InputRightElement>
        </InputGroup>
      ) : type === "number" ? (
        <NumberInput
          bg="white"
          borderRadius="lg"
          focusBorderColor="primary.main"
          {...inputProps}
        >
          <NumberInputField
            id={inputId}
            aria-invalid={hasError}
            aria-describedby={hasError ? errorId : undefined}
          />
          <NumberInputStepper>
            <NumberIncrementStepper />
            <NumberDecrementStepper />
          </NumberInputStepper>
        </NumberInput>
      ) : (
        <Input
          id={inputId}
          type={type}
          bg="white"
          borderRadius="lg"
          focusBorderColor="primary.main"
          aria-invalid={hasError}
          aria-describedby={hasError ? errorId : undefined}
          {...inputProps}
        />
      )}
      {hasError && (
        <FormErrorMessage id={errorId} role="alert" aria-live="polite">
          {errors}
        </FormErrorMessage>
      )}
    </FormControl>
  );
}
